import { getKeys } from './getKeys'

export const familyPortalSettingsTranslations = {
  CUSTOMISATION_TITLE: 'Family app customisation',
  CUSTOMISATION_SUBTITLE:
    'Customise what families will be able to view in the Family App. These changes will be applied to all family members using the Family App.',
  FEATURES_CARD_TITLE: 'Features',
  DOCUMENTS: 'Documents',
  CARE_PLANS_AND_RISK_ASSESSMENTS:
    '{{carePlansNominative}} (inc. documents) and Risk Assessments',
  MEDICATIONS: 'Medications',
  ROSTERING: 'Rostering',
  ROTA_ON_FAMILY_APP: 'Rota on Family App',
  ROTA_ON_FAMILY_APP_SUBTITLE:
    'Customise which information is shown on the Family App for rota',
  ROTA_VISIT_INFORMATION: 'Visit information',
  ROTA_VISIT_INFORMATION_DESCRIPTION:
    'Controls visibility of visit details shown to families: duration, time, title, visit type, and address.',
  ROTA_ALWAYS_SHOWN: 'Always shown',
  ROTA_TEAM_MEMBERS_ALLOCATED: 'Team members allocated',
  ROTA_TEAM_MEMBERS_ALLOCATED_DESCRIPTION:
    'Shows or hides the name and profile picture of team members assigned to each visit.',
  ROTA_CLOCK_IN_OUT: 'Clock in / Clock out details',
  ROTA_CLOCK_IN_OUT_DESCRIPTION:
    'When enabled, families will see the clock in and clock out time and the team member responsible. Ensure appropriate consent has been obtained before enabling this option.',
  ROTA_REQUIRES_TEAM_MEMBERS: 'Requires Team members allocated to be enabled',
  ROTA_LAST_UPDATED_BY: 'Last updated by',
  ROTA_LAST_UPDATED_BY_DESCRIPTION:
    "Displays the date and time of the last update, along with the team member's picture and name who made the change.",
  FAMILY_APP_PREVIEW: 'Family app preview',
  LOG_DETAILS: 'Log Details',
  TIME_OF_LOG: 'Time of Log',
  LOG_DETAILS_TIME_DESCRIPTION:
    'A specific time will not be shown if you choose to hide the time. The timeline of logs will be in the order that they were logged.',
  DISPLAY_LOG_TIMES: 'Display log times',
  LOGGED_BY: 'Logged by',
  LOG_DETAILS_LOGGED_BY_DESCRIPTION:
    "If consent has been obtained from staff to share their name, you can show the names of the team member that wrote the log to family members in the App. This increases your service's transparency, but you need to ensure you have permission from your team.",
  DISPLAY_CARER_NAMES: 'Display carer names',
  SHOW: 'Show',
  HIDE: 'Hide',
  FAMILY_PORTAL_VISIBLE_LOGS: 'Family App Logs',
  LOGS_SUBTITLE:
    'If you would like to customise the logs that families can see whilst using the app, you can toggle them on and off here. Remember, these changes will be applied to all of the members that are using the App for your service.',
  LOGS_NOTE_LABEL: 'Note:',
  LOGS_NOTE: 'Family members cannot see custom logs',
  SHOW_IN_FAMILY_PORTAL: 'Show in Family App',
  SAVE_CHANGES: 'Save changes',
  SAVED: 'Saved',
  SAVE_FAILED: 'Failed to save',
  NAVIGATION_MODAL_CONTENT:
    'Are you sure you want to leave? Any unsaved changes will be lost.'
}

export const familyPortalSettingsConstants = getKeys(
  familyPortalSettingsTranslations
)
